import React, { useState, useEffect } from "react";
import { Row, Col, Button, Modal, Spin } from "antd";
import EmailVerify from "@/Verification/EmailVerify";
import PhoneVerify from "@/Verification/PhoneVerify";
import ReadMore from "./ReadMore";
import PassWordVerify from "./PassWordVerify";
import { get } from "$ACTIONS/TlcRequest";
import { ApiPort } from "$ACTIONS/TLCAPI";
function OtpPopUp({
    otpVisible,
    otpModal,
    otpParam,
    memberInfo,
    kindOfVerification,
    GetThroughoutVerification,
}) {
    // 初次彈窗顯示，控制彈窗，彈窗類別參數，會員信息
    const [readStep, setReadStep] = useState(0); // 0 選擇驗證框、1 了解更多框   4.密码修改
    const [phoneVisible, setPhoneVisible] = useState(false); // 彈手機驗證框
    const [emailVisible, setEmailVisible] = useState(false); // 彈email驗證框
    const [phoneattemptRemaining, setPhoneAttemptRemaining] = useState(5); // phone电话剩餘次數
    const [emailattemptRemaining, setEmailAttemptRemaining] = useState(5); // 邮箱剩餘次數
    const [loading, setLoading] = useState(false); // 加载状态
    const [initialAttempt, setInitialAttemp] = useState(false); //剩餘次數初始化完成

    useEffect(() => {
        GetInitialVerifyAttemp();
    }, []);

    useEffect(() => {
        if (initialAttempt) {
            SendPiwikUrl();
        }
    }, [initialAttempt]);

    const prams = {
        // 引用參數
        memberInfo: memberInfo && memberInfo,
        otpParam: otpParam,
        times: 5,
        phoneattemptRemaining: phoneattemptRemaining,
        setPhoneAttemptRemaining: setPhoneAttemptRemaining,
        kindOfVerification: kindOfVerification && kindOfVerification,
        emailattemptRemaining: emailattemptRemaining,
        setEmailAttemptRemaining: setEmailAttemptRemaining,
        GetThroughoutVerification: GetThroughoutVerification,
    };

    let verifyList;
    if (phoneattemptRemaining <= 0 && emailattemptRemaining > 0) {
        verifyList = [
            {
                name: "Email",
                content: "ยืนยันข้อมูลอีเมล", //通过邮箱验证
                defaultImg: "/th/img/user/otpVerify/e.svg",
            },
        ];
    } else if (emailattemptRemaining <= 0 && phoneattemptRemaining > 0) {
        verifyList = [
            {
                name: "Phone",
                content: "ยืนยันข้อมูลเบอร์โทร", //通过手机验证
                defaultImg: "/th/img/user/otpVerify/p.svg",
            },
        ];
    } else if (emailattemptRemaining > 0 && phoneattemptRemaining > 0) {
        verifyList = [
            {
                name: "Phone",
                content: "ยืนยันข้อมูลเบอร์โทร", //通过手机验证
                defaultImg: "/th/img/user/otpVerify/p.svg",
            },
            {
                name: "Email",
                content: "ยืนยันข้อมูลอีเมล", //通过邮箱验证
                defaultImg: "/th/img/user/otpVerify/e.svg",
            },
        ];
    }

    const VerifyCategory = (otpVisible, emailVisible, phoneVisible) => {
        otpModal(otpVisible);
        setEmailVisible(emailVisible);
        setPhoneVisible(phoneVisible);
        if (otpVisible) {
            SendPiwikUrl();
        }
    };

    const GetInitialVerifyAttemp = async () => {
        try {
            setLoading(true);
            const [res1, res2] = await Promise.all([
                get(
                    ApiPort.GETOTPAttempts +
                        `&channelType=Email&serviceAction=${kindOfVerification}`
                ),
                get(
                    ApiPort.GETOTPAttempts +
                        `&channelType=SMS&serviceAction=${kindOfVerification}`
                ),
            ]);
            if (res1?.isSuccess && res1?.result !== "") {
                setEmailAttemptRemaining(res1.result);
            }
            if (res2?.isSuccess && res2?.result !== "") {
                setPhoneAttemptRemaining(res2.result);
            }
        } catch (error) {
            console.error("Error GETOTPAttempts 获取用户验证次数:", error);
        } finally {
            setLoading(false);
            setInitialAttemp(true);
        }
    };

    const SendPiwikUrl = () => {
        if (kindOfVerification === "Revalidate") {
            global.Pushgtagpiwikurl && global.Pushgtagpiwikurl("reset_password", "Reset Password");
        } else if (kindOfVerification === "OTP") {
            if (phoneattemptRemaining && emailattemptRemaining) {
                global.Pushgtagpiwikurl && global.Pushgtagpiwikurl("login_security_verification", "Login Security Verification");
            }
            if (!phoneattemptRemaining && emailattemptRemaining) {
                global.Pushgtagpiwikurl && global.Pushgtagpiwikurl("login_otp_email", "Phone Exceed 5 times OTP Email");
            }
            if (phoneattemptRemaining && !emailattemptRemaining) {
                global.Pushgtagpiwikurl && global.Pushgtagpiwikurl("exceed5times_otp_phone", "Email Exceed 5 times OTP Phone");
            }
            if (!phoneattemptRemaining && !emailattemptRemaining) {
                global.Pushgtagpiwikurl && global.Pushgtagpiwikurl("exceed5times_otp_cslink", "Phone&Email Exceed 5 times CS Link");
            }
        }
    };

    return (
        <React.Fragment>
            <Modal
                title={
                    readStep == 1
                        ? "ความปลอดภัยของระบบบัญชี"
                        : "การตรวจสอบความปลอดภัย"
                } //安全公告/安全验证
                className={`${readStep === 0 ? "loginOTPModal" : ""} ${
                    readStep == 1 ? "SecurityAnnouncement" : ""
                } modal-pubilc OTP-modal`}
                visible={otpVisible}
                closable={readStep == 1 ? true : false}
                centered={true}
                width={readStep == 0 ? 400 : 500}
                footer={null}
                zIndex={1500}
                onCancel={() => {
                    setReadStep(0);
                }}
            >
                {loading && (
                    <Spin size="large" tip="กำลังโหลด กรุณารอสักครู่..." />
                )}
                {/* 加载中，请稍后... */}
                {readStep == 0 && (
                    <React.Fragment>
                        <Row>
                            <Col span={24}>
                                <div className="otp-modal-description">
                                    โปรดตรวจสอบข้อมูลของคุณเพื่อให้แน่ใจว่าบัญชีของคุณปลอดภัยจากการป้องกันทางไซเบอร์,การป้องกันการโจรกรรมและลดความเสี่ยงในการทำธุรกรรม
                                    <Button
                                        className="otpBtn"
                                        onClick={() => {
                                            setReadStep(1);
                                            Pushgtagdata(
                                                "Login_Security_Verification",
                                                "Learn more",
                                                "Login_Security_Verification_V_More"
                                            );
                                        }}
                                        block
                                    >
                                        ข้อมูลเพิ่มเติม
                                    </Button>
                                </div>
                            </Col>

                            <div className="OtpList">
                                {memberInfo &&
                                    verifyList &&
                                    verifyList.map((item, index) => {
                                        // 可驗證管道
                                        if (
                                            !memberInfo.isVerifiedEmail &&
                                            item.name == "Email"
                                        )
                                            return;
                                        return (
                                            <div key={index} className="otpBox">
                                                <div
                                                    className={`verify-icon-wrap`}
                                                    onClick={() => {
                                                        Pushgtagdata(
                                                            "Login_Security_Verification",
                                                            `Select ${item.name} OTP`,
                                                            `Login_Security_Verification_C_${item.name}`
                                                        );
                                                        VerifyCategory(
                                                            false,
                                                            item.name ===
                                                                "Email",
                                                            item.name === "Phone"
                                                        );
                                                    }}
                                                >
                                                    <img
                                                        className="verify-icon"
                                                        src={item.defaultImg}
                                                        alt={item.name}
                                                    />
                                                </div>
                                                <Button
                                                    type="primary"
                                                    style={{
                                                        padding: "0px 6px",
                                                    }}
                                                    onClick={() => {
                                                        Pushgtagdata(
                                                            "Login_Security_Verification",
                                                            `Select ${item.name} OTP`,
                                                            `Login_Security_Verification_C_${item.name}`
                                                        );
                                                        VerifyCategory(
                                                            false,
                                                            item.name ===
                                                                "Email",
                                                            item.name === "Phone"
                                                        );
                                                    }}
                                                >
                                                    {item.content}
                                                </Button>
                                            </div>
                                        );
                                    })}
                            </div>
                            {!verifyList && (
                                <div className="OtpList">
                                    <div className="otpBox">
                                        <div
                                            className={`verify-icon-wrap`}
                                            onClick={() => {
                                                if (
                                                    kindOfVerification !==
                                                    "Revalidate"
                                                ) {
                                                    PopUpLiveChat();
                                                } else if (
                                                    kindOfVerification ===
                                                    "Revalidate"
                                                ) {
                                                    PopUpLiveChat();
                                                    global.globalExit();
                                                }
                                            }}
                                        >
                                            <img
                                                className="verify-icon"
                                                src="/th/img/user/otpVerify/cs.svg"
                                                alt="CS"
                                            />
                                        </div>
                                        <Button
                                            type="primary"
                                            style={{ padding: "0px 6px" }}
                                            onClick={() => {
                                                if (
                                                    kindOfVerification !==
                                                    "Revalidate"
                                                ) {
                                                    PopUpLiveChat();
                                                } else if (
                                                    kindOfVerification ===
                                                    "Revalidate"
                                                ) {
                                                    PopUpLiveChat();
                                                    global.globalExit();
                                                }
                                            }}
                                        >
                                            เจ้าหน้าที่ฝ่ายบริการ
                                            {/* 联系在线客服 */}
                                        </Button>
                                    </div>
                                </div>
                            )}
                            <br />
                            <Button
                                onClick={() => {
                                    Pushgtagdata(
                                        "Login_Security_Verification",
                                        "Skip Verification",
                                        "Login_Security_Verification_C_Skip"
                                    );
                                    global.globalExit();
                                }}
                                block
                                ghost
                            >
                                ยืนยันภายหลัง{/* 跳过验证 */}
                            </Button>
                        </Row>
                    </React.Fragment>
                )}
                {/* 了解更多 */}
                {readStep == 1 && (
                    <ReadMore
                        VerifyCategory={VerifyCategory}
                        setReadStep={setReadStep}
                        kindOfVerification={kindOfVerification}
                    />
                )}
            </Modal>
            {emailVisible && (
                <EmailVerify
                    {...prams}
                    closeModal={() => {
                        VerifyCategory(true, false, false);
                    }}
                    visible={emailVisible}
                    email={
                        memberInfo.isVerifiedEmail &&
                        memberInfo.isVerifiedEmail[0]
                    }
                    changeVerify={VerifyCategory}
                    setReadStep={setReadStep}
                    kindOfVerifications={kindOfVerification}
                    isAllowChange={true}
                />
            )}
            {phoneVisible && (
                <PhoneVerify
                    {...prams}
                    closeModal={() => {
                        VerifyCategory(true, false, false);
                    }}
                    visible={phoneVisible}
                    phone={
                        memberInfo.isVerifiedPhone &&
                        memberInfo.isVerifiedPhone[0]
                    }
                    changeVerify={VerifyCategory}
                    modalTitle={`ยืนยันข้อมูลเบอร์โทรศัพท์`} //手机验证
                    setReadStep={setReadStep}
                    kindOfVerifications={kindOfVerification}
                    isAllowChange={true}
                />
            )}
            {readStep == 4 && (
                <PassWordVerify
                    otpPwdVisible={readStep == 4} // 彈窗顯示
                    // otpPwdVisible={otpVisible} // 用来直接显示修改密码的弹窗测试用
                    setReadStep={setReadStep}
                    VerifyCategory={VerifyCategory}
                />
            )}
        </React.Fragment>
    );
}

export default OtpPopUp;
